import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'

const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
    height: '48px',
    backgroundColor: 'rgba(212, 12, 32, 0.15)',
    borderRadius: '6px',
    border: '1px solid rgba(212, 12, 32, 0.15)',
  },
  message: {
    fontSize: '16 px',
    lineHeight: '20px',
    letterSpacing: '0.016em',
    color: '#d40c20',
  },
  icon: {
    color: '#d40c20',
  },
}))

const InfoBox = ({ type = 'error', message = '' }) => {
  const classes = useStyles({ type })
  return (
    <Alert variant="filled" severity={type} classes={classes}>
      {message}
    </Alert>
  )
}

export default memo(InfoBox)
